import { render, staticRenderFns } from "./BusinessAnnualReturnFormFiles.vue?vue&type=template&id=0fdc781c&scoped=true&"
import script from "./BusinessAnnualReturnFormFiles.vue?vue&type=script&lang=js&"
export * from "./BusinessAnnualReturnFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAnnualReturnFormFiles.vue?vue&type=style&index=0&id=0fdc781c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc781c",
  null
  
)

export default component.exports